import { render } from "./DistributionModal.vue?vue&type=template&id=63ccc1ff&scoped=true"
import script from "./DistributionModal.vue?vue&type=script&lang=js"
export * from "./DistributionModal.vue?vue&type=script&lang=js"

import "./DistributionModal.vue?vue&type=style&index=0&id=63ccc1ff&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ccc1ff"]])

export default __exports__